export default ({ style }) => (
	<svg
		id="Layer_3"
		data-name="Layer 3"
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 27 27"
	>
		<path
			style={style}
			className="cls-1"
			d="M17.077,13.318a.25.25,0,0,0-.25-.25H6.48a.251.251,0,0,0-.25.25v7.71a.25.25,0,0,0,.25.25H16.827a.249.249,0,0,0,.25-.25V19.1l3.64,1.607a.233.233,0,0,0,.1.021.249.249,0,0,0,.137-.04.252.252,0,0,0,.113-.21V13.419a.249.249,0,0,0-.35-.228L17.077,14.8Zm-.5,7.46H6.73v-7.21h9.847v7.21Zm3.99-6.975v6.3l-3.49-1.541V15.344Z"
		/>
		<path
			style={style}
			className="cls-1"
			d="M9.262,12.379a3.323,3.323,0,0,0,2.965-1.847A2.641,2.641,0,1,0,12.5,8.324a3.326,3.326,0,1,0-3.242,4.055Zm5.475-4.794A2.147,2.147,0,1,1,12.59,9.732,2.149,2.149,0,0,1,14.737,7.585ZM9.262,6.222A2.829,2.829,0,1,1,6.433,9.051,2.832,2.832,0,0,1,9.262,6.222Z"
		/>
		<path
			style={style}
			className="cls-1"
			d="M9.262,10.725A1.674,1.674,0,1,0,7.588,9.051,1.676,1.676,0,0,0,9.262,10.725Zm0-2.848A1.174,1.174,0,1,1,8.088,9.051,1.175,1.175,0,0,1,9.262,7.877Z"
		/>
		<path
			style={style}
			className="cls-1"
			d="M14.737,11.087a1.355,1.355,0,1,0-1.354-1.355A1.357,1.357,0,0,0,14.737,11.087Zm0-2.209a.855.855,0,1,1-.854.854A.856.856,0,0,1,14.737,8.878Z"
		/>
		<path
			style={style}
			className="cls-1"
			d="M14.237,16.957l-4.328-2.5a.25.25,0,0,0-.375.217v5a.25.25,0,0,0,.125.216.247.247,0,0,0,.25,0l4.328-2.5a.25.25,0,0,0,0-.433Zm-4.2,2.282V15.108l3.578,2.065Z"
		/>
	</svg>
)
